import { lazy } from "react";
import { Navigate } from "react-router-dom";
import ArchivedAdminFeature from "../components/common/ArchivedAdminFeature";

// NOTE: Course catalogue/approval, Commission/fee config, and the old
// course-marketplace subscription-plan editor were retired by the Ilmaivo
// pivot (course marketplace -> session booking). Their page components
// still exist on disk (never deleted, per archive policy) but are no
// longer imported/routed here - old links now render ArchivedAdminFeature.
// See: src/app/(admin)/courses/*, src/app/(admin)/fee/page.jsx,
// src/app/(admin)/subscriptionList/page.jsx

const ChangePassword = lazy(() => import("../app/(admin)/changePassword/page"));
const Payout = lazy(() => import("../app/(admin)/payouts/page"));
const PayoutRuns = lazy(() => import("../app/(admin)/payout-runs/page"));
const MoneyReconciliation = lazy(() => import("../app/(admin)/money-reconciliation/page"));
const WhatsAppDelivery = lazy(() => import("../app/(admin)/whatsapp-delivery/page"));
const RightsCases = lazy(() => import("../app/(admin)/rights-cases/page"));
const Report = lazy(() => import("../app/(admin)/ReportSection/page"));
const CommunicationPage = lazy(() => import("../app/(admin)/sendEmail/page"));
const Setting = lazy(() => import("../app/(admin)/setting/page"));
const Tickets = lazy(() => import("../app/(admin)/Tickets/page"));
const Transactions = lazy(() => import("../app/(admin)/Transaction/page"));
const UserManagement = lazy(() => import("../app/(admin)/userManagement/page"));
const UserDetail = lazy(() => import("../app/(admin)/userManagement/userDetail/page"));
const UserDetailView = lazy(() => import("../app/(admin)/userManagement/userInfo/page"));
const UserSubscription = lazy(() => import("../app/(admin)/subscriptionListing/page"));
const Analytics = lazy(() => import("../app/(admin)/analytics/page"));
const ProductAnalytics = lazy(() => import("../app/(admin)/product-analytics/page"));
const Bookings = lazy(() => import("../app/(admin)/bookings/page"));
const FeeTerms = lazy(() => import("../app/(admin)/feeTerms/page"));
const ContractTerms = lazy(() => import("../app/(admin)/contractTerms/page"));
const SignedContractOnboardings = lazy(() => import("../app/(admin)/signedContractOnboardings/page"));

const Login = lazy(() => import("../app/(other)/auth/login/page"));
const Logout = lazy(() => import("../app/(other)/auth/logout/page"));
const AdminPage = lazy(() => import("../app/(admin)/admin/page"));
const Dashboard = lazy(() => import("../app/(admin)/dashboard/page"));
const Banner = lazy(() => import("../app/(admin)/banner/page"));
const Calendar = lazy(() => import("../app/(admin)/calendar/page"));
const StarterPage = lazy(() =>
    import("../app/(admin)/pages/starter-page/page")
);
const FaqPages = lazy(() => import("../app/(admin)/pages/faqs/page"));
const FeatureVideo = lazy(() =>
    import("../app/(admin)/pages/videoInsight/page")
);
const MaintenancePages = lazy(() => import("../app/(other)/maintenance/page"));
const TimelinePages = lazy(() => import("../app/(admin)/pages/timeline/page"));
const ComingSoonPage = lazy(() => import("../app/(other)/coming-soon/page"));
const TermsConditions = lazy(() => import("../app/(admin)/pages/terms/page"));
const Error404Alt = lazy(() =>
    import("../app/(admin)/pages/error-404-alt/page")
);
// error
const Error401 = lazy(() => import("../app/(other)/errors/error-401/page"));
const Error400 = lazy(() => import("../app/(other)/errors/error-400/page"));
const Error403 = lazy(() => import("../app/(other)/errors/error-403/page"));
const Error404 = lazy(() => import("../app/(other)/errors/error-404/page"));
const Error500 = lazy(() => import("../app/(other)/errors/error-500/page"));
const ServiceUnavailable = lazy(() =>
    import("../app/(other)/errors/service-unavailable/page")
);
const initialRoutes = [
    {
        path: "/",
        name: "root",
        element: <Navigate to="/dashboard" />,
    },
];

// dashboards
const generalRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        element: <Dashboard />,
    },
    {
        path: "/analytics",
        name: "Analytics",
        element: <Analytics />,
    },
    {
        path: "/product-analytics",
        name: "Product Analytics",
        element: <ProductAnalytics />,
    },
    {
        path: "/report",
        name: "Gift Card",
        element: <Report />,
    },
    {
        path: "/change-password",
        name: "Change Password",
        element: <ChangePassword />,
    },

    {
        path: "/user-management",
        name: "User Management",
        element: <UserManagement />,
    },


    {
        path: "/user-management/:id",
        name: "User Detail",
        element: <UserDetail />,
    },

    {
        path: "/user-management/:id/view",
        name: "User Info",
        element: <UserDetailView />,
    },

    {
        path: "/bookings",
        name: "Bookings",
        element: <Bookings />,
    },
    {
        path: "/signed-contract-onboardings",
        name: "Signed-contract onboarding",
        element: <SignedContractOnboardings />,
    },


    {
        path: "/courses",
        name: "Courses (Archived)",
        element: <ArchivedAdminFeature />,
    },
    {
        path: "/courses/detail/:id",
        name: "Courses (Archived)",
        element: <ArchivedAdminFeature />,
    },


    {
        path: "/setting",
        name: "User Detail",
        element: <Setting />,
    },
    {
        path: "/commission",
        name: "Commission (Archived)",
        element: <ArchivedAdminFeature />,
    },

    {
        path: "/transactions",
        name: "Transactions",
        element: <Transactions />,
    },



    {
        path: "/edit-course/:id",
        name: "Edit Course (Archived)",
        element: <ArchivedAdminFeature />,
    },
    {
        path: "/edit-course-seo/:id",
        name: "Edit SEO Information (Archived)",
        element: <ArchivedAdminFeature />,
    },







    {

        path: "/subscriotion",
        name: "Subscriotion (Archived)",
        element: <ArchivedAdminFeature />,

    },

    {
        path: "/subscriptionListing",
        name: "Subscription Listing",
        element: <UserSubscription />

    },

    {

        path: "/tickets",
        name: "Tickets",
        element: <Tickets />,

    },
    {

        path: "/payouts",
        name: "Payouts",
        element: <Payout />,

    },
    {
        path: "/payout-runs",
        name: "Payout Runs",
        element: <PayoutRuns />,
    },
    {
        path: "/money-reconciliation",
        name: "Money Reconciliation",
        element: <MoneyReconciliation />,
    },
    {
        path: "/whatsapp-delivery",
        name: "WhatsApp Delivery",
        element: <WhatsAppDelivery />,
    },
    {
        path: "/rights-cases",
        name: "Rights Cases",
        element: <RightsCases />,
    },
    {

        path: "/fee-terms",
        name: "Fee Terms",
        element: <FeeTerms />,

    },

    // Org contract terms sits beside Fee Terms deliberately: both are
    // super-admin commercial-terms surfaces for one organization. There is no
    // /organizations/:id route on this branch, so this screen carries its own
    // organization picker.
    {
        path: "/contract-terms",
        name: "Contract Terms",
        element: <ContractTerms />,
    },



    {

        path: "/course/:id1/:id2/reviews",
        name: "Course Reviews (Archived)",
        element: <ArchivedAdminFeature />,

    },




    {

        path: "/communication-page",
        name: "Subscriotion",
        element: <CommunicationPage />,

    },



    {
        path: "/admin",
        name: "Admin",
        element: <AdminPage />,
    },
    {
        path: "/banner",
        name: "Banner",
        element: <Banner />,
    },
    {
        path: "pages/feature-video",
        name: "Coupon",
        element: <FeatureVideo />,
    },
];
const appsRoutes = [
    {
        path: "/calendar",
        name: "Calendar",
        element: <Calendar />,
    },
];

// pages
const customPagesRoutes = [
    {
        path: "/pages/starter-page",
        name: "Starter Page",
        element: <StarterPage />,
    },
    {
        path: "/pages/faqs",
        name: "FAQ",
        element: <FaqPages />,
    },
    {
        path: "/pages/terms",
        name: "Terms & Conditions",
        element: <TermsConditions />,
    },
    {
        path: "/pages/timeline",
        name: "Timeline",
        element: <TimelinePages />,
    },
    {
        path: "/pages/error-404-alt",
        name: "Error 404 Alt",
        element: <Error404Alt />,
    },
];

// auth
const authRoutes = [
    {
        path: "/auth/login",
        name: "Login",
        element: <Login />,
    },

    {
        path: "/auth/logout",
        name: "Logout",
        element: <Logout />,
    },
];

// public routes
const otherPublicRoutes = [
    {
        path: "/errors/error-401",
        name: "401 Unauthorized",
        element: <Error401 />,
    },
    {
        path: "/errors/error-400",
        name: "400 Bad Reques",
        element: <Error400 />,
    },
    {
        path: "/coming-soon",
        name: "Coming Soon",
        element: <ComingSoonPage />,
    },
    {
        path: "/errors/error-403",
        name: "403 Forbidden",
        element: <Error403 />,
    },
    {
        path: "/errors/error-404",
        name: "404 Not Found",
        element: <Error404 />,
    },
    {
        path: "/errors/error-500",
        name: "500 Internal Server",
        element: <Error500 />,
    },
    {
        path: "/errors/service-unavailable",
        name: "Service Unavailable",
        element: <ServiceUnavailable />,
    },
    {
        path: "/maintenance",
        name: "Maintenance",
        element: <MaintenancePages />,
    },
];
export const appRoutes = [
    ...initialRoutes,
    ...generalRoutes,
    ...customPagesRoutes,
    ...appsRoutes,
];
export const publicRoutes = [
    ...authRoutes,
    ...otherPublicRoutes,
];
